"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var server_1 = __importDefault(require("react-dom/server"));
var global_any_1 = __importDefault(require("./SharedComponents/global-any"));
var HeaderNav_1 = __importDefault(require("../Components/HeaderNav/HeaderNav"));
var LogoutButton_1 = __importDefault(require("../Components/HeaderNav/LogoutButton"));
var MyCommittees_1 = __importDefault(require("./MyCommittees"));
//Grid Components
var Accordion_1 = __importDefault(require("../Components/GridComponents/AccordionComponent/Accordion"));
var Tab_1 = __importDefault(require("../Components/GridComponents/TabComponent/Tab"));
var FeaturedPods_1 = __importDefault(require("../Components/GridComponents/FeaturedPodsComponent/FeaturedPods"));
var ImagePods_1 = __importDefault(require("../Components/GridComponents/ImagePodsComponent/ImagePods"));
var PartnerPods_1 = __importDefault(require("../Components/GridComponents/PartnerPodsComponent/PartnerPods"));
var MembershipPods_1 = __importDefault(require("../Components/GridComponents/MembershipPodsComponent/MembershipPods"));
var BannerSlider_1 = __importDefault(require("../Components/GridComponents/BannerSliderComponent/BannerSlider"));
var TestimonialCarousel_1 = __importDefault(require("../Components/GridComponents/TestimonialCarouselComponent/TestimonialCarousel"));
var ChartsLegendsComponent_1 = __importDefault(require("../Components/GridComponents/Charts/ChartsLegendsComponent/ChartsLegendsComponent"));
var PieChartComponent_1 = __importDefault(require("../Components/GridComponents/Charts/PieChartComponent/PieChartComponent"));
var HorizontalBarChartComponent_1 = __importDefault(require("../Components/GridComponents/Charts/HorizontalBarChartComponent/HorizontalBarChartComponent"));
var DownloadLink_1 = __importDefault(require("../Components/GridComponents/DownloadLinkComponent/DownloadLink"));
var DocumentLibrary_1 = __importDefault(require("../Components/DocumentLibraryComponent/DocumentLibrary"));
var EvidenceUpload_1 = __importDefault(require("./AttributesAndEvidence/EvidenceUpload"));
var DownloadPdfReportComponent_1 = __importDefault(require("./DownloadReport/DownloadPdfReportComponent"));
var DownloadCsvReportComponent_1 = __importDefault(require("./DownloadReport/DownloadCsvReportComponent"));
global_any_1.default.React = react_1.default;
global_any_1.default.ReactDOM = react_dom_1.default;
global_any_1.default.ReactDOMServer = server_1.default;
global_any_1.default.HeaderNav = HeaderNav_1.default;
global_any_1.default.LogoutButton = LogoutButton_1.default;
global_any_1.default.MyCommittees = MyCommittees_1.default;
global_any_1.default.AccordionComponent = Accordion_1.default;
global_any_1.default.TabComponent = Tab_1.default;
global_any_1.default.FeaturedPodsComponent = FeaturedPods_1.default;
global_any_1.default.ImagePodsComponent = ImagePods_1.default;
global_any_1.default.BannerSliderComponent = BannerSlider_1.default;
global_any_1.default.PartnerPodsComponent = PartnerPods_1.default;
global_any_1.default.MembershipPodsComponent = MembershipPods_1.default;
global_any_1.default.TestimonialCarouselComponent = TestimonialCarousel_1.default;
global_any_1.default.ChartsLegendsComponent = ChartsLegendsComponent_1.default;
global_any_1.default.PieChartComponent = PieChartComponent_1.default;
global_any_1.default.HorizontalBarChartComponent = HorizontalBarChartComponent_1.default;
global_any_1.default.DownloadLinkComponent = DownloadLink_1.default;
global_any_1.default.DocumentLibraryComponent = DocumentLibrary_1.default;
global_any_1.default.EvidenceUploadComponent = EvidenceUpload_1.default;
global_any_1.default.DownloadPdfReportComponent = DownloadPdfReportComponent_1.default;
global_any_1.default.DownloadCsvReportComponent = DownloadCsvReportComponent_1.default;
